var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("INJURY")]),_c('h4',[_vm._v("Physical damage or trauma arising wholly and exclusively from an Accident or other events of violent or external, and visible nature.")])])
}]

export { render, staticRenderFns }